<script setup lang="ts">
// 2026-10-07 (Paolo): Charteris (silver) top strip — CHARTERIS · SI · GC · FX, the Gold strip's template tied to silver.
// CharterisSparklineBar self-polls, so `ctx` is accepted (uniform strip contract) and ignored.
import CharterisSparklineBar from '../charteris/CharterisSparklineBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'
defineProps<{ ctx: SignalTabCtx }>()
</script>
<template><CharterisSparklineBar /></template>
